import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Box,
  LinearProgress,
  Button,
  TextField as TxtField,
} from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { ConfirmButton } from ".";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { WatchActions, useDispatch } from "../../../../state";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

interface Props {
  brand_id: number;
  aka_rule: any;
  brand: any;
  stub: any;
  sites_router_metum: any;
  custom_aka: boolean;
  can_delete: boolean;
  myTitle: any;
  id: any;
  myBrand: any;
  brandListTitle: any;
  setMyBrand: any;
  setMyBrandId: any;
  setEditBrand: any;
  myBrandId: any;
  setGroupDetailsData: any;
  brandTitle: any;
  attribute: any;
  rawAttribute: any;
  setIsDisabled: any;
  isDisabled: boolean;
}

export function SeriesSeo(props: Props) {
  const dispatch = useDispatch();
  const [bgColor, setBgColor] = useState();
  const siteId = useSelector((state: any) => state.scopes.site_id);

  return (
    <div style={{ width: "100%" }}>
      <Formik
        initialValues={{
          ...props,
        }}
        onSubmit={(values) => {
          dispatch(
            WatchActions.editSeries(
              `/details-value/${props.id}?field=${props.attribute}&site=${siteId}`,
              values,
              props.myBrandId,
            ),
          );
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            {true && (
              <Box
                boxShadow={1}  // Changed from 5
                display="flex"
                flexWrap="wrap"
                flexDirection="column"
                alignItems="left"
                my={1}  // Changed from 4
                p={1}   // Changed from 2
                pt={1}  // Changed from 2
                margin={"auto"}
                bgcolor={"white"}
                borderRadius={"4px"}
                maxWidth="800px"  // Add this to constrain width
                onLoad={props.setGroupDetailsData(values)}
                onKeyUp={(e: any) => {
                  props.setGroupDetailsData(values);
                  props.setIsDisabled(false);
                }}
              >
                <Box mx={1} my={0.5} display="flex" justifyContent="space-between">  {/* Changed m={1} to mx/my */}
                  {props.attribute === "series" ? (
                    <Field
                      component={TextField}
                      name="series"
                      label="Series name"
                      style={{ width: "350px" }}  // Changed from 46%
                      disabled={siteId !== 0}
                      size="small"  // Add this
                    />
                  ) : props.attribute === "series_group" ? (
                    <Field
                      component={TextField}
                      name="series_group"
                      label="Series Group"
                      style={{ width: "350px" }}  // Changed from 46%
                      disabled={siteId !== 0}
                      size="small"  // Add this
                    />
                  ) : (
                    <Field
                      component={TextField}
                      name={props.attribute}
                      label="Group Name"
                      style={{ width: "350px" }}  // Changed from 50%
                      disabled={siteId !== 0}
                      size="small"  // Add this
                    />
                  )}
                  {props?.hasOwnProperty(`brand_id`) && (
                    <Autocomplete
                      disabled={siteId !== 0}
                      size="small"  // Add this
                      inputValue={props.myBrand}
                      defaultValue={props.myTitle}
                      id="combo-box-demo"
                      options={props.brandListTitle}
                      getOptionLabel={(option) => option.title || ""}
                      onChange={(event, value) => {
                        if (value) {
                          props.setMyBrand(value?.title);
                          props.setMyBrandId(value?.id);
                          props.setIsDisabled(false);
                          if (props.setEditBrand) {
                            props.setEditBrand(value?.id);
                          }
                        }
                      }}
                      style={{ width: "350px" }}  // Changed from 53%
                      renderInput={(params) => (
                        <TxtField
                          {...params}
                          label="Brand Affiliation"
                          defaultValue={props.brandTitle}
                          size="small"  // Add this
                        />
                      )}
                    />
                  )}
                </Box>
                <Box>
                  <Box mx={1} my={0.5} display="flex" justifyContent="space-between">  {/* Changed m={1} */}
                    {props.attribute.startsWith("series") && (
                      <Field
                        component={TextField}
                        name="stub"
                        label="Series Items URL"
                        style={{ width: "350px" }}  // Changed from 46%
                        size="small"  // Add this
                      />
                    )}
                    {values.stub && (
                      <Field
                        component={TextField}
                        name="sites_router_metum.title"
                        label="Brand Items Title"
                        style={{ width: "350px" }}  // Changed from 53%
                        size="small"  // Add this
                      />
                    )}
                  </Box>
                  <Box mx={1} my={0.5}>  {/* Changed m={1} */}
                    {values.stub && (
                      <Field
                        multiline={true}
                        fullWidth={true}
                        component={TextField}
                        name="sites_router_metum.description"
                        label="Series Items Meta Description"
                        size="small"  // Add this
                      />
                    )}
                  </Box>
              
                  <Box mx={1} my={0.5}>  {/* Changed m={1} */}
                    {values.stub && (
                      <Field
                        multiline={true}
                        fullWidth={true}
                        component={TextField}
                        name="sites_router_metum.keywords"
                        label="Series Items Meta Keywords"
                        size="small"  // Add this
                      />
                    )}
                  </Box>
                  <Box mx={1} my={0.5}>  {/* Changed m={1} */}
                    {values.stub && (
                      <Field
                        multiline={true}
                        fullWidth={true}
                        component={TextField}
                        name="sites_router_metum.headers"
                        label="Series Items Other SEO"
                        size="small"  // Add this
                      />
                    )}
                  </Box>
                </Box>
              
                <Box mx={1} my={0.5} display="flex" justifyContent="space-between">  {/* Changed m={1} */}
                  {isSubmitting && <LinearProgress />}
                  {!props.attribute?.endsWith("_group") && (
                    <Button
                      variant="contained"
                      size="small"  // Add this
                      color="primary"
                      disabled={props.isDisabled}
                      onClick={submitForm}
                      component={Link}
                      to={`/watch-attribute-affiliated/series`}
                    >
                      Edit Series
                    </Button>
                  )}
              
                  {props.can_delete && (
                    <ConfirmButton
                      attribute={props.attribute}
                      myValue={values.brand}
                      myBrand={values.brand}
                      myBrandId={values.brand_id}
                      id={props.id}
                      rawAttribute={props.rawAttribute}
                      Add_Edit_Delete={"delete"}
                      color={"secondary"}
                      disabled={false}
                      path={
                        props.attribute.startsWith("series")
                          ? "watch-attribute-affiliated"
                          : "watch-attribute-groups"
                      }
                    />
                  )}
                </Box>
              </Box>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}
